const presential_fr = require('./presential.json')
export default presential_fr